// Portfolio Index Page
import { lazy, Suspense } from "react";
import { Navigation } from "@/components/layout/Navigation";
import { HeroSection } from "@/components/sections/HeroSection";
import { SEO } from "@/components/SEO";
import { AnimatedBackground } from "@/components/AnimatedBackground";
import { BackToTop } from "@/components/BackToTop";
import { EasterEggs } from "@/components/EasterEggs";
// Lazy load non-critical sections
const AboutSection = lazy(() =>
  import("@/components/sections/AboutSection").then((m) => ({
    default: m.AboutSection,
  })),
);
const EducationSection = lazy(() =>
  import("@/components/sections/EducationSection").then((m) => ({
    default: m.EducationSection,
  })),
);
const SkillsSection = lazy(() =>
  import("@/components/sections/SkillsSection").then((m) => ({
    default: m.SkillsSection,
  })),
);
const ProjectsSection = lazy(() =>
  import("@/components/sections/ProjectsSection").then((m) => ({
    default: m.ProjectsSection,
  })),
);
const BlogSection = lazy(() =>
  import("@/components/sections/BlogSection").then((m) => ({
    default: m.BlogSection,
  })),
);
const ContactSection = lazy(() =>
  import("@/components/sections/ContactSection").then((m) => ({
    default: m.ContactSection,
  })),
);
const Footer = lazy(() =>
  import("@/components/sections/Footer").then((m) => ({ default: m.Footer })),
);

// Lightweight loading fallback with min-height to prevent layout shift
const SectionLoader = () => (
  <div
    className="section-padding flex items-center justify-center"
    style={{ minHeight: "400px" }}
  >
    <div className="animate-pulse text-muted-foreground">Loading...</div>
  </div>
);

const Index = () => {
  return (
    <>
      <SEO />
      <AnimatedBackground />
      <div className="relative z-10 min-h-screen">
        <Navigation />
        <main>
          <HeroSection />
          <Suspense fallback={<SectionLoader />}>
            <AboutSection />
          </Suspense>
          <Suspense fallback={<SectionLoader />}>
            <EducationSection />
          </Suspense>
          <Suspense fallback={<SectionLoader />}>
            <SkillsSection />
          </Suspense>
          <Suspense fallback={<SectionLoader />}>
            <ProjectsSection />
          </Suspense>
          <Suspense fallback={<SectionLoader />}>
            <BlogSection />
          </Suspense>
          <Suspense fallback={<SectionLoader />}>
            <ContactSection />
          </Suspense>
        </main>
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
        <BackToTop />
        <EasterEggs />
      </div>
    </>
  );
};

export default Index;
